<div
  class="shell"
  [class.shell--sidebar-mini]="isSidebarMini"
  [class.shell--mobile]="isMobileView"
  [class.shell--chat-open]="isChatOpen"
>
  <div
    class="shell__backdrop"
    *ngIf="isMobileView"
    [class.shell__backdrop--visible]="!isSidebarMini"
    (click)="closeSidebar()"
  ></div>
  <div class="shell__side-bar" [style.width.px]="sidebarWidth">
    <sgt-sidebar-menu
      [items]="menuItems"
      [isSidebarMini]="isMobileView ? false : isSidebarMini"
      (isSidebarMiniChange)="isSidebarMini = $event"
    >
    </sgt-sidebar-menu>
  </div>
  <div class="shell__page">
    <div class="shell__page-top-navbar">
      <sgt-header
        [isSidebarMini]="isSidebarMini"
        (toggleSidebar)="onToggleSidebar($event)"
      >
      </sgt-header>
    </div>
    <main class="shell__page-main">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<sgt-chat-panel></sgt-chat-panel>

<sgt-preferences-modal></sgt-preferences-modal>
